import React, { useState, useEffect } from "react";
import { Stage, Layer, Group } from "react-konva";
import State from "../../components/MachineElement/State.jsx";
import "../Dashboard/Dashboard.css";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import colors from "../../constants/colors";
import { useDot } from "../../context/automatonContext";
import { useLoading } from "../../context/Feedback/loadingContext";
import { useSystem } from "../../context/systemContext";
import Loading from "../../components/Loading/loading";
import { useUser } from "../../context/userContext";
import { organizeArrayToRenderAutomata } from "../../utils/organizeRenderAutomata.js";
import TutorialAutomaton from "../../components/Dialogs/TutorialAutomatonDialog";
import HowToUseGrammarDialog from "components/Dialogs/HowToUseGrammarDialog";
import ImportDot from "../../components/Dialogs/ImportDotDialog";
import constants from "../../constants/automatonLabel";
import constantAlert from "../../constants/Feedback/validationAutomata";
import constantsValidationAutomata from "../../constants/Feedback/validationAutomata";

import { useAlert } from "context/Feedback/alertContext.jsx";
import HistoricalDialog from "components/Dialogs/HistoricalDialog.jsx";
import RegextoAutomatonDialog from "components/Dialogs/RegexToAutomatonDialog.jsx";
import Transition from "components/MachineElement/Transition.jsx";
import SystemOff from "views/System/SystemOff.jsx";
import SimulateWordDialog from "components/Dialogs/SimulateWord.jsx";
import DOT from "../../components/MachineElement/DOT";

export default function Dashboard() {
  // eslint-disable-next-line no-unused-vars
  const [_posStars, setStarts] = useState([]);
  let temporaryArray = [];
  const [machineStatePositions, setMachineStatePositions] = useState({});
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  // eslint-disable-next-line no-unused-vars
  const [_numberStates, setNumberStates] = useState(0);
  const [numberElements, setNumberElements] = useState(0);
  const [typeClick, setTypeClick] = useState({
    createState: true,
    connecting: false,
    editState: false,
    editTransition: false,
  });
  const [readyToConect, setReadyToConect] = useState(false);
  const [transition, setTransition] = useState({
    initial: { text: "", xPos: 0, yPos: 0 },
    final: { text: "", xPos: 0, yPos: 0 },
    label: "λ",
  });
  const [currentState, setCurrentState] = useState(null);
  const [currentTransition, setCurrentTransition] = useState(null);
  const [openEditState, setOpenEditState] = useState(false);
  const [openEditTransition, setOpenEditTransition] = useState(false);
  const [startTouch, setStartTouch] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [tranT, setTranT] = useState([]);
  const {
    dot,
    setDot,
    setArrayElements,
    setActualMachine,
    childs1,
    setChilds,
    machineStates,
    setMachineStates,
    machineTransitions,
    setMachineTransitions,
  } = useDot();
  const { isAlive } = useSystem();
  const { setAlert } = useAlert();
  const { loading } = useLoading();
  const { language, isAdmin } = useUser();

  const [editedText, setEditedText] = useState(currentState?.text || "");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (currentState?.text) {
      setEditedText(currentState.text);
    }
  }, [currentState?.text]);

  /**
   *
   * Atualiza o texto na ediçao
   *
   */
  useEffect(() => {}, [editedText]);

  /**
   *
   * Atualiza o texto do estado conforme o usuário digita.
   *
   * @param {Object} event - Evento do input de texto.
   *
   */
  const handleTextChange = (event) => {
    setEditedText(event.target.value);
  };

  /**
   *
   * Ativa o modo de edição para alterar o nome do estado.
   *
   */
  const handleEditClick = () => {
    setEditedText(currentState?.text || "");
    setIsEditing(true);
  };

  /**
   *
   * Atualiza o nome e ID do estado atual.
   *
   * @param {string} newName - Novo nome para o estado.
   */

  const changeNameAndIdState = (newName) => {
    if (!currentState) {
      return;
    }

    const updatedStates = machineStates.map((state) => {
      if (state.id === currentState.id) {
        return { ...state, text: newName, id: newName };
      }
      return state;
    });

    setMachineStates(updatedStates);
    setCurrentState((prevState) => ({
      ...prevState,
      text: newName,
      id: newName,
    }));
  };

  /**
   *
   * Atualiza as transições que fazem referência ao estado.
   *
   * @param {string} oldName - Nome anterior do estado.
   * @param {string} newName - Novo nome do estado.
   */

  const updateTransitionsWithState = (oldName, newName) => {
    const updatedTransitions = machineTransitions.map((transition) => {
      if (transition.initial.text === oldName) {
        transition.initial.text = newName;
      }
      if (transition.final.text === oldName) {
        transition.final.text = newName;
      }
      return transition;
    });
    setMachineTransitions(updatedTransitions);
  };

  /**
   *
   * Confirma a alteração do nome do estado atual, verificando validações.
   *
   */
  const handleConfirmClick = () => {
    if (!currentState) {
      return;
    }

    const oldName = currentState.text;

    if (editedText.trim() === "") {
      setEditedText(oldName);
      setAlert({
        active: true,
        text: constantsValidationAutomata.validState.error.emptyName[language],
        color: "warning",
      });
      return;
    }

    if (editedText === oldName) {
      setIsEditing(false);
      return;
    }

    if (machineStates.some((state) => state.text === editedText)) {
      setAlert({
        active: true,
        text: constantsValidationAutomata.validState.error.nameInUse[language],
        color: "warning",
      });
      return;
    }

    changeNameAndIdState(editedText);
    updateTransitionsWithState(oldName, editedText);

    setCurrentState((prevState) =>
      prevState ? { ...prevState, text: editedText, id: editedText } : null
    );

    setIsEditing(false);
  };

  useEffect(() => {
    document.addEventListener("contextmenu", function (event) {
      event.preventDefault();
    });
    if (getHighestState() == 0) {
      setNumberStates(getHighestState());
    } else {
      setNumberStates(getHighestState() + 1);
    }

    if (dot.length > 0) {
      drawDOTtoAutomaton(dot);
    }
  }, [dot]);

  const handleClickOpen = (obj) => {
    setCurrentTransition(obj);
    setOpenEditTransition(true);
    let el = document.getElementById("text-transition");
    el.setSelectionRange(0, el.value.length);
  };

  const handleClose = () => {
    setOpenEditTransition(false);
    setOpenEditState(false);
    setEditedText("");
    setIsEditing(false);
  };
  const existTransition = (initial, final) => {
    let flag = false;
    for (let t of tranT) {
      if (t != null) {
        if (t.props.initial.text == final && t.props.final.text == initial) {
          flag = true;
        }
      }
    }
    return flag;
  };
  const updateTransitions = () => {
    setTimeout(() => {
      for (let t of tranT) {
        if (t != null) {
          const s1 = t.props.initial.text;
          const s2 = t.props.final.text;
          if (existTransition(s1, s2)) {
            t.updateTransitionPosition(true);
          } else {
            t.updateTransitionPosition(false);
          }
        }
      }
    }, 10);
  };
  const handleShapeDragEnd = (e, machineState, index) => {
    var shape = e.target;
    const newX = shape.getX();
    const newY = shape.getY();
    let tempState = [...machineStates];
    let obj = tempState[index];
    obj = Object.assign(obj, { x: newX, y: newY });
    tempState.splice(index, 1, obj);
    setMachineStates(tempState);
    for (let t of tranT) {
      if (t != null) {
        if (t.props.initial.text == machineState.props.text) {
          t.props.initial.xPos = newX;
          t.props.initial.yPos = newY;
        }
        if (t.props.final.text == machineState.props.text) {
          t.props.final.xPos = newX;
          t.props.final.yPos = newY;
        }
        t.updateTransitionPosition();
      }
    }
  };
  const createState = (x, y) => {
    const tempState = [...machineStates];
    const tempStatePositions = machineStatePositions;

    let tempNumberState = 0;
    while (machineStates.some((state) => state.id === `q${tempNumberState}`)) {
      tempNumberState++;
    }
    tempState.push({
      id: "q" + tempNumberState,
      text: "q" + tempNumberState,
      color: colors.stateColor,
      x: x || mousePosition.x,
      y: y || mousePosition.y,
      isInitial: false,
      isFinal: false,
      visible: true,
    });
    tempStatePositions["q" + tempNumberState] = {
      id: "q" + tempNumberState,
      text: "q" + tempNumberState,
      color: colors.stateColor,
      x: x || mousePosition.x,
      y: y || mousePosition.y,
      isInitial: false,
      isFinal: false,
      visible: true,
    };
    setMachineStatePositions({ ...tempStatePositions });
    setMachineStates(tempState);
    setNumberStates(tempNumberState + 1);
    setNumberElements(numberElements + 1);
  };

  const createTransition = () => {
    let tempState = [...machineTransitions];
    let existeTransicao = false;
    let transitionExist;
    tempState.forEach((obj) => {
      if (
        obj.initial.text == transition.initial.text &&
        obj.final.text == transition.final.text
      ) {
        existeTransicao = true;
        transitionExist = obj;
      }
    });
    if (!existeTransicao) {
      const tran = {
        initial: transition.initial,
        final: transition.final,
        label: transition.label,
        stroke: "black",
        strokeWidth: 1,
      };
      tempState.push(tran);
      setMachineTransitions(tempState);
      handleClickOpen(tran);
    } else {
      const index = machineTransitions.indexOf(transitionExist);
      transitionExist.stroke = "red";
      transitionExist.strokeWidth = 2;
      tempState.splice(index, 1, transitionExist);
      setMachineTransitions(tempState);

      setTimeout(() => {
        transitionExist.stroke = "black";
        transitionExist.strokeWidth = 1;
        tempState.splice(index, 1, transitionExist);
        setMachineTransitions(tempState);
      }, 500);
    }
  };

  const selectEelement = (e) => {
    let comparator;
    if (e.target.attrs.id != undefined) {
      comparator = e.target.attrs.id;
    } else if (e.target.attrs.text != undefined) {
      comparator = e.target.attrs.text;
    }
    const element = machineStates.filter(
      (obj) => obj != null && obj.id == comparator
    )[0];
    return element;
  };

  const changeStateColor = (id, color) => {
    const fakeElement = {
      target: {
        attrs: {
          id: id,
        },
      },
    };
    let initialState = selectEelement(fakeElement);
    initialState.color = color;
  };

  const handleClickState = (e, stateKonva) => {
    const button = e.evt.button;
    let state = selectEelement(e);
    if (state == undefined) {
      const fakeElement = {
        target: {
          attrs: {
            id: stateKonva.props.text,
          },
        },
      };
      state = selectEelement(fakeElement);
    }
    let transitionTemp = transition;
    if (button == 0) {
      if (readyToConect) {
        const final = {
          text: state.text,
          xPos: state.x,
          yPos: state.y,
        };
        transitionTemp.final = final;

        changeStateColor(transition.initial.text, colors.stateColor);
        setTransition(transitionTemp);
        setReadyToConect(false);
        setCurrentState({});
        createTransition();
      } else {
        state.color = colors.grayishGreen;
        const initial = {
          text: state.text,
          xPos: state.x,
          yPos: state.y,
        };
        transitionTemp.initial = initial;
        setReadyToConect(true);
        setCurrentState(state);
        setTransition(transitionTemp);
      }
    } else if (button == 2) {
      let state = selectEelement(e);
      state.color = colors.stateColor;
      setCurrentState(state);
      setOpenEditState(true);
      setReadyToConect(false);
    }
  };

  const handleClick = (e) => {
    const place = e.target.constructor.name;
    const button = e.evt.button;
    const isTouch = e.evt.type === "touchend" ? true : false;

    const { x, y } = e.currentTarget.getPointerPosition();

    if (button === 0 || isTouch) {
      if (place === "Stage") {
        if (readyToConect) {
          changeStateColor(transition.initial.text, colors.stateColor);
          setReadyToConect(false);
          setCurrentState({});
        } else {
          createState(x, y);
        }
      }
    }
  };

  const handleMouseMove = (e) => {
    const pos = {
      x: e.evt.layerX,
      y: e.evt.layerY,
    };
    setMousePosition(pos);
  };

  const handleChangeLabelTransition = (e) => {
    let tempState = [...machineTransitions];
    const index = tempState.indexOf(currentTransition);
    currentTransition.label = e.target.value.replace(".", "λ");
    tempState.splice(index, 1, currentTransition);
    setMachineTransitions(tempState);
  };
  const changeTypeState = (type) => {
    let tempState = [...machineStates];
    const index = machineStates.indexOf(currentState);
    if (type.includes("+")) {
      if (currentState["isInitial"] && currentState["isFinal"]) {
        currentState["isInitial"] = false;
        currentState["isFinal"] = false;
      } else {
        currentState["isInitial"] = true;
        currentState["isFinal"] = true;
      }
    } else {
      if (currentState["isInitial"] && type == "isFinal") {
        currentState["isInitial"] = false;
        currentState["isFinal"] = true;
      } else if (currentState["isFinal"] && type == "isInitial") {
        currentState["isFinal"] = false;
        currentState["isInitial"] = true;
      } else {
        currentState[type] = !currentState[type];
      }
    }
    tempState.splice(index, 1, currentState);
    setMachineStates(tempState);
    handleClose();
  };
  const handleDeleteTransition = () => {
    let tempTransition = [...machineTransitions];
    const index = tempTransition.indexOf(currentTransition);
    tempTransition.splice(index, 1);
    setMachineTransitions(tempTransition);

    let dot = new DOT(machineStates, tempTransition);
    dot.toDotLanguage();
    setDot(dot.toString());
    handleClose();
  };

  const handleDeleteState = () => {
    let tempState = [...machineStates];
    let tempTransitions = [...machineTransitions];
    let tranTemp = [];
    const index = tempState.indexOf(currentState);
    tempState.splice(index, 1);
    let statesDeleted = [];
    for (let i = 0; i < tempTransitions.length; i++) {
      const el = tempTransitions[i];
      if (el.initial.text == currentState.text) {
        el.vis = false;
        statesDeleted.push(el.initial.text);
      }
      if (el.final.text == currentState.text) {
        el.vis = false;
        statesDeleted.push(el.final.text);
      }
    }
    let array = tempTransitions.filter((el) => el.vis != false);

    for (let t of tranT) {
      if (t != null) {
        if (
          !statesDeleted.includes(t.props.initial.text) &&
          !statesDeleted.includes(t.props.final.text)
        ) {
          tranTemp.push(t);
        }
      }
    }

    setTranT(tranTemp);
    setMachineStates(tempState);
    setMachineTransitions(array);
    updateTransitions();
    handleClose();
  };

  const drawDOTtoAutomaton = (dot) => {
    try {
      let highestState = 0;
      setScreenWidth(window.innerWidth);
      const arrayRender = organizeArrayToRenderAutomata(dot);
      for (let i = 0; i < arrayRender.states.length; i++) {
        const state = arrayRender.states[i];
        const numberState = parseInt(state.text.split("q")[1], 10);
        if (state.x > screenWidth) {
          setScreenWidth(state.x + 50);
        }
        if (state.y > screenHeight) {
          setScreenHeight(state.y + 50);
        }
        if (numberState > highestState) {
          highestState = numberState;
        }
      }
      setMachineStates(arrayRender.states);
      setMachineTransitions(arrayRender.transitions);

      setActualMachine(temporaryArray);
      setNumberStates(highestState + 1);
      setArrayElements(childs1);
      updateTransitions();
    } catch (e) {
      setDot("");
      setAlert({
        active: true,
        text: constantAlert.invalidFormat[language],
        color: "warning",
        sevarity: "error",
      });
    }
  };
  const handleStateTouch = (e) => {
    if (!typeClick.connecting) {
      let state = selectEelement(e);

      const typeClick = {
        createState: true,
        connecting: true,
        editState: false,
        editTransition: false,
      };

      setTypeClick(typeClick);

      if (state != undefined) {
        setTransition(
          Object.assign(transition, {
            initial: {
              text: state.text,
              xPos: state.x,
              yPos: state.y,
            },
          })
        );
        state = Object.assign(state, { color: colors.grayishGreen });
        let machineStateTemp = [...machineStates];
        const index = machineStateTemp.indexOf(state);

        machineStateTemp.splice(index, 1, state);
        setMachineStates(machineStateTemp);
      }
    } else if (typeClick.connecting) {
      const state = selectEelement(e);
      if (state != undefined) {
        setTransition(
          Object.assign(transition, {
            final: {
              text: state.text,
              xPos: state.x,
              yPos: state.y,
            },
          })
        );
      }

      const typeClick = {
        createState: true,
        connecting: false,
        editState: false,
        editTransition: false,
      };
      const fakeElement = {
        target: {
          attrs: {
            id: transition.initial.text,
          },
        },
      };

      let initialState = selectEelement(fakeElement);
      initialState = Object.assign(initialState, {
        color: colors.stateColor,
      });
      let machineStateTemp = [...machineStates];
      const index = machineStateTemp.indexOf(initialState);

      machineStateTemp.splice(index, 1, initialState);
      setMachineStates(machineStateTemp);

      setTypeClick(typeClick);
      createTransition();
    }
  };
  const touchEditState = (e) => {
    if (new Date().getTime() - startTouch > 300) {
      const state = selectEelement(e);
      setCurrentState(state);
      setOpenEditState(true);
    }
  };
  const getHighestState = () => {
    let highestState = 0;
    for (let state of machineStates) {
      const numberState = parseInt(state.text.split("q")[1], 10);
      if (numberState > highestState) {
        highestState = numberState;
      }
    }
    return highestState;
  };

  const displayText = (text) => {
    if (!text) {
      return "";
    }
    const maxNameLength = 12;
    if (text.length > maxNameLength) {
      return text.substring(0, maxNameLength - 3) + "...";
    } else {
      return text;
    }
  };

  if (!isAlive && !isAdmin) {
    return <SystemOff />;
  }
  return (
    <div>
      <Loading loading={loading} />
      <div>
        <Dialog
          open={openEditTransition}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          onKeyUp={(e) => {
            const ENTER = 13;
            if (e.keyCode === ENTER) {
              handleClose();
            }
          }}
        >
          <DialogTitle id="form-dialog-title">
            <div className="wrapper-title">
              {(currentTransition != null &&
                `${constants.dialog.transition[language]} ${
                  currentTransition.initial.text || ""
                } → ${currentTransition.final.text || ""}`) ||
                ""}
              <div
                className="wrapper-button-close button-margin"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  style={{ backgroundColor: "#999", color: "#FFF" }}
                  onClick={handleClose}
                >
                  X
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <TextField
              id="text-transition"
              autoFocus
              margin="dense"
              value={currentTransition != null ? currentTransition.label : ""}
              onChange={(e) => {
                handleChangeLabelTransition(e);
              }}
              type="text"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button color="black" onClick={handleClose}>
              OK
            </Button>
            <Button onClick={handleDeleteTransition} color="secondary">
              {constants.dialog.delete[language]}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openEditState}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            <div
              className="wrapper-title"
              style={{
                width: "400px",
                height: "35px",
              }}
            >
              {constants.dialog.state[language]}:
              {isEditing ? (
                <TextField
                  value={editedText}
                  onChange={handleTextChange}
                  autoFocus
                  onFocus={(e) => e.target.select()}
                  placeholder={`${currentState?.text || ""}`}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleConfirmClick();
                    }
                  }}
                  variant="outlined"
                  size="small"
                  className="edit-text-field"
                  style={{
                    margin: "0 8px",
                    width: "35 px",
                    paddingLeft: "8px",
                  }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                />
              ) : (
                <span
                  style={{
                    margin: "0 8px",
                    width: "35 px",
                    paddingLeft: "8px",
                  }}
                >
                  {displayText(currentState?.text)}
                </span>
              )}
              <div
                className="wrapper-buttons"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {isEditing ? (
                  <Button
                    style={{
                      backgroundColor: "#4CAF50",
                      color: "#FFF",
                      marginRight: "8px",
                    }}
                    onClick={handleConfirmClick}
                  >
                    <span>&#10003;</span>
                  </Button>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#007BFF",
                      color: "#FFF",
                      marginRight: "8px",
                    }}
                    onClick={handleEditClick}
                  >
                    <EditIcon style={{ color: "#FFF" }} />
                  </Button>
                )}
                <Button
                  style={{ backgroundColor: "#999", color: "#FFF" }}
                  onClick={handleClose}
                >
                  X
                </Button>
              </div>
            </div>
          </DialogTitle>
          <DialogActions>
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  id="isInitial"
                  color="black"
                  style={{
                    backgroundColor:
                      currentState != null &&
                      currentState.isInitial &&
                      !currentState.isFinal
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isInitial");
                  }}
                >
                  {constants.dialog.initial[language]}
                </Button>
                <Button
                  id="isFinal"
                  color="black"
                  style={{
                    backgroundColor:
                      currentState != null &&
                      currentState.isFinal &&
                      !currentState.isInitial
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isFinal");
                  }}
                >
                  {constants.dialog.final[language]}
                </Button>
                <Button
                  id="isInitial+isFinal"
                  color="black"
                  style={{
                    backgroundColor:
                      currentState != null &&
                      currentState.isFinal &&
                      currentState.isInitial
                        ? colors.pressButtonState
                        : "",
                  }}
                  onClick={() => {
                    changeTypeState("isInitial+isFinal");
                  }}
                >
                  {constants.dialog.initialAndfinal[language]}
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "10px",
                }}
              >
                <Button
                  onClick={handleDeleteState}
                  color="secondary"
                  style={{ backgroundColor: colors.redLight }}
                  fullWidth
                >
                  {constants.dialog.delete[language]}
                </Button>
              </div>
            </div>
          </DialogActions>
        </Dialog>
        <TutorialAutomaton />
        <ImportDot setStars={setStarts} setChilds={setChilds} />
        <RegextoAutomatonDialog setStars={setStarts} setChilds={setChilds} />
        <HistoricalDialog setStars={setStarts} setChilds={setChilds} />
        <SimulateWordDialog setStars={setStarts} setChilds={setChilds} />

        <HowToUseGrammarDialog />
        <div className="response-area">
          <div className="stage">
            <Group id="group" width={screenWidth}>
              <Stage
                style={{ overflow: "auto" }}
                width={screenWidth}
                height={screenHeight}
                onClick={handleClick}
                onTap={handleClick}
                onMouseMove={handleMouseMove}
                onContextMenu={(e) => {
                  e.evt.preventDefault();
                }}
              >
                <Layer>
                  {machineTransitions.map((obj, index) => {
                    return (
                      <Transition
                        key={index}
                        initial={obj.initial}
                        final={obj.final}
                        label={obj.label}
                        stroke={obj.stroke}
                        strokeWidth={obj.strokeWidth}
                        onClick={() => {
                          handleClickOpen(obj);
                        }}
                        onTap={() => {
                          handleClickOpen(obj);
                        }}
                        ref={(iam) => {
                          let temp = tranT;
                          if (!temp.includes(iam)) {
                            temp.push(iam);
                            setTranT(temp);
                          }
                        }}
                      />
                    );
                  })}
                  {machineStates.map((obj, index) => (
                    <State
                      id={obj.id}
                      key={obj.id}
                      x={obj.x}
                      y={obj.y}
                      color={obj.color != undefined ? obj.color : "#e9eaea"}
                      text={obj.text}
                      isInitial={obj.isInitial}
                      isFinal={obj.isFinal}
                      visible={obj.visible}
                      draggable={true}
                      onClick={(e, element) => {
                        handleClickState(e, element);
                      }}
                      onDragEnd={(e, element) => {
                        handleShapeDragEnd(e, element, index);
                      }}
                      onTap={(e, element) => {
                        handleStateTouch(e, element);
                      }}
                      onTouchStart={() => {
                        setStartTouch(new Date().getTime());
                      }}
                      onTouchEnd={(e, element) => {
                        touchEditState(e, element);
                      }}
                    />
                  ))}
                </Layer>
              </Stage>
            </Group>
          </div>
        </div>
      </div>
    </div>
  );
}
